export interface IState {
  workorderTypeList: any;
  workorderList: any;
  workorderCount: any;
  workorderDetails: any;
  workorderTaskData: any;
  workOrderColumn: any;
}

type Action = any;

export const workOrderReducer = (
  state: IState = {
    workorderTypeList: [],
    workorderList: [],
    workorderCount: 0,
    workorderDetails: null,
    workorderTaskData: [],
    workOrderColumn: [],
  },
  action: Action
): any => {
  switch (action.type) {
    case "GET_WORKORDER_TYPE":
      return {
        ...state,
        workorderTypeList:
          action?.payload?.page == 1 ? action?.payload?.data : [...state?.workorderTypeList, ...action?.payload?.data],
      };

    case "GET_WORK_ORDERS":
      return {
        ...state,
        workorderList:
          action?.payload?.page == 1 ? action?.payload?.data : [...state?.workorderList, ...action?.payload?.data],
        workorderCount: action?.payload?.count,
      };
    case "CLEAR_WORK_ORDERS":
      return {
        ...state,
        workorderList: [],
      };
    case "GET_WORK_ORDER_DETAILS":
      return {
        ...state,
        workorderDetails: action?.payload?.data?.length > 0 ? action?.payload?.data[0] : {},
      };
    // case "GET_WORK_ORDER_TASK_DATA":
    //   return {
    //     ...state,
    //     workorderTaskData: action?.payload?.data?.length > 0 ? action?.payload?.data : [],
    //   };
    case "CHANGE_WORK_ORDER_STATUS":
      return {
        ...state,
        workorderDetails:
          state?.workorderDetails?._id == action?.payload?.id
            ? { ...state?.workorderDetails, status: action?.payload?.status }
            : state?.workorderDetails,
      };
    case "GET_WORK_ORDER_COLUMN":
      return {
        ...state,
        workOrderColumn: action?.payload?.selected ? action?.payload?.selected : [],
      };
    case "CLEAR_WORK_ORDER_LIST":
      return {
        ...state,
        workorderList: [],
      };
    case "SET_WORK_ORDER_TASK_DEPENDENCY_DATA":
      return {
        ...state,
        workorderTaskData: action?.payload,
      };

    default:
      return state;
  }
};
